import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-title" }
const _hoisted_2 = {
  key: 0,
  role: "status"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_4 = ["srcdoc"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalConsulte = _resolveComponent("ModalConsulte")!

  return (_openBlock(), _createBlock(_component_ModalConsulte, {
    ref: "modal",
    "hide-footer": false,
    modalWidth: "720px"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", _hoisted_1, "Comprovante de " + _toDisplayString(_ctx.titulosComprovante[_ctx.tipo]), 1)
    ]),
    content: _withCtx(() => [
      (_ctx.carregando)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Carregando os dados gravados…"))
        : _createCommentVNode("", true),
      (_ctx.erro)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.erro), 1))
        : _createCommentVNode("", true),
      (_ctx.dados)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "papel-comprovante",
              class: "form-label"
            }, "Tipo de impressora / papel", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "papel-comprovante",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.papel) = $event)),
              class: "form-select mb-2",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pronto = false))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("option", { value: "58" }, "Térmica — bobina de 58 mm", -1),
              _createElementVNode("option", { value: "80" }, "Térmica — bobina de 80 mm", -1),
              _createElementVNode("option", { value: "A4" }, "Impressora comum — A4", -1)
            ]))], 544), [
              [_vModelSelect, _ctx.papel]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "small text-muted" }, " Na impressão, selecione a impressora e o papel correspondente, use escala de 100% e desative cabeçalhos e rodapés. Para a bobina, habilite o corte automático no driver da impressora. ", -1)),
            _createElementVNode("iframe", {
              ref: "previa",
              srcdoc: _ctx.html,
              title: "Pré-visualização do comprovante",
              sandbox: "allow-same-origin allow-modals",
              class: "w-100 border",
              style: {"height":"420px"},
              onLoad: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pronto = true))
            }, null, 40, _hoisted_4)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fechar && _ctx.fechar(...args)))
      }, "Fechar"),
      (_ctx.erro)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.carregar && _ctx.carregar(...args)))
          }, " Tentar novamente "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: !_ctx.dados || !_ctx.pronto || _ctx.carregando,
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
      }, " Imprimir ", 8, _hoisted_5)
    ]),
    _: 1
  }, 512))
}